<template>
  <div class="cline">
    © 2021 {{ $config.cline }}. Alle Rechte vorbehalten. made by
    <a
      class="text-white external"
      href="http://www.novagraphix.de"
      target="_blank"
      >novagraphix</a
    >
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.cline {
  margin-inline: 2rem;
  color: var(--clr-footer-cline);
  font-size: var(--fz-footer-cline);
  font-weight: var(--fw-footer-cline);
  a {
    text-decoration: none;
    color: var(--clr-footer-cline);
    &:hover {
      color: var(--clr-footer-cline-hover);
    }
  }
}
</style>
